import React from "react";
import { ContentsStyle, MainStyle, Wrap } from "./styles";
import GnbHeader from "components/Common/GnbHeader/GnbHeader";
import useMediaView from "features/common/hooks/useMediaView";
import GnbHeaderMobile from "../GnbHeader/Mobile";

const Layout = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  const isSmallView = useMediaView("small");

  return (
    <Wrap {...rest}>
      {!isSmallView && <GnbHeader />}
      {isSmallView && <GnbHeaderMobile />}
      <MainStyle>
        {/* GNB Header가 들어갈 영역 */}
        <ContentsStyle>{children}</ContentsStyle>
      </MainStyle>
    </Wrap>
  );
};

export default Layout;
